import { Observable } from 'app/utils/observable';

export const isDragging$ = new Observable<boolean>(false);
